var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightedLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.4333 6.68667C14.1733 6.31334 13.7133 6.1 13.1867 6.1H10.4533C10.2733 6.1 10.1067 6.02667 9.99333 5.89334C9.87333 5.76 9.82667 5.57334 9.85333 5.38L10.1933 3.19334C10.34 2.54 9.90667 1.80667 9.25333 1.58667C8.64667 1.36 7.93333 1.66667 7.64667 2.1L4.83333 6.28L4.75333 6.41334V12.3067L4.85333 12.4067L6.96667 14.04C7.24667 14.32 7.88 14.4733 8.32667 14.4733H10.9267C11.82 14.4733 12.72 13.8 12.92 12.98L14.56 7.98667C14.7333 7.51334 14.6867 7.05334 14.4333 6.68667Z",
    fill: "#402E96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47333 4.25336H2.78667C1.75333 4.25336 1.33333 4.65336 1.33333 5.64002V12.3467C1.33333 13.3334 1.75333 13.7334 2.78667 13.7334H3.47333C4.50667 13.7334 4.92667 13.3334 4.92667 12.3467V5.64002C4.92667 4.65336 4.50667 4.25336 3.47333 4.25336Z",
    fill: "#402E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedLike);
export default __webpack_public_path__ + "static/media/highlighted-like.9cae84cc2cdd40a5926f4d22aaf4a932.svg";
export { ForwardRef as ReactComponent };